import axios from 'axios'
import { notification } from 'ant-design-vue'
import Cookie from 'js-cookie'
import router from '@/router'

const SUCCESS_CODE = 200
	// 超时逻辑
;(axios.defaults as any).retry = 3
;(axios.defaults as any).retryDelay = 2000
// ;(axios.defaults as any).withCredentials = true

const instance = axios.create({
	// baseURL: baseURL,
	timeout: 10000,
	headers: {
		'X-Requested-type': 'Axios',
	},
})

instance.interceptors.request.use((config: any) => {
	//通用请求头之前
	const userId = Cookie.get('userId')
	const token = Cookie.get('accessToken')

	// console.log(config)
	if (token) {
		config.headers['access-token'] = token
	}
	if (userId) {
		config.headers['user-id'] = userId
	}

	return config
})

// eslint-disable-next-line complexity
instance.interceptors.response.use(
	(response: any) => {
		return new Promise((resolve, reject) => {
			if (response.status === SUCCESS_CODE) {
				if (
					response.data.code === 9001 ||
					response.data.code === 9002
				) {
					Cookie.remove('userId')
					Cookie.remove('accessToken')
					// 未登录的情况下跳到登录页面
					// 9001:access-token不能为空
					// 9002:access-token无效
					if (
						location.pathname === '/join' ||
						location.pathname === '/authentication'
					) {
						router.replace({
							name: 'login',
							query: {
								redirect:
									location.pathname === '/join'
										? 'join'
										: '/',
							},
						})
					}
					return
				}
				//全局返回响应
				resolve(response.data)
			} else {
				reject(response)
			}
		})
	},
	(err) => {
		const config = err.config
		// description: config.url,
		notification.error({
			message: '服务器错误，请稍后重试',
			description:''
		})
		// If config does not exist or the retry option is not set, reject
		if (!config || !config.retry) return Promise.reject(err)

		// Set the variable for keeping track of the retry count
		config.__retryCount = config.__retryCount || 0

		// Check if we've maxed out the total number of retries
		if (config.__retryCount >= config.retry) {
			// Reject with the error
			return Promise.reject(err)
		}

		// Increase the retry count
		config.__retryCount += 1

		// Create new promise to handle exponential backoff
		const backoff = new Promise(function(resolve) {
			setTimeout(function() {
				resolve()
			}, config.retryDelay || 1)
		})

		// Return the promise in which recalls axios to retry the request
		return backoff.then(function() {
			return axios(config)
		})
	}
)

export default instance
